export const removeEmptyTranslations = (translationList) => {
  if (!translationList) return [];
  return translationList.filter(
    (translation) =>
      translation.translatedValue &&
      translation.translatedValue.trim().length > 0
  );
};